import { useState, useEffect } from 'react'
import { useWcbApi } from './use-wcb-api'

interface UseWcbRateProps {
  wcbCode: string
  subdivisionId: number
  organizationId?: number
}

export const useWcbRate = ({ wcbCode, subdivisionId, organizationId }: UseWcbRateProps) => {
  const [wcbRate, setWcbRate] = useState<number>(0)
  const [wcbRateLoading, setWcbRateLoading] = useState(false)
  const [wcbRateError, setWcbRateError] = useState<string | null>(null)
  
  const wcbApi = useWcbApi()

  const fetchWcbRate = async () => {
    if (!wcbCode) {
      setWcbRate(0)
      return
    }

    if (!organizationId || organizationId === 0) {
      console.log('No organization ID provided - skipping WCB rate lookup')
      setWcbRate(0)
      return
    }

    setWcbRateLoading(true)
    setWcbRateError(null)

    try {
      console.log(`Fetching WCB rate for:`, {
        wcbCode,
        subdivisionId,
        organizationId
      })

      const rate = await wcbApi.getWCBRateForCode(wcbCode, subdivisionId, organizationId)
      setWcbRate(rate)

      if (rate === 0) {
        console.warn(`⚠️ No WCB rate found for code "${wcbCode}" in organization ${organizationId}. Using 0% rate.`)
      } else {
        console.log(`✅ Successfully loaded WCB rate: ${rate}%`)
      }

    } catch (error) {
      console.error('Failed to fetch WCB rate:', error)
      setWcbRate(0)
      setWcbRateError('Failed to load organization-specific WCB rate')
    } finally {
      setWcbRateLoading(false)
    }
  }

  useEffect(() => {
    fetchWcbRate()
  }, [wcbCode, organizationId, subdivisionId])

  return {
    wcbRate,
    wcbRateLoading,
    wcbRateError,
    refetchWcbRate: fetchWcbRate
  };
}; 